var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpBooksApiV5Request } from "./http-api-request.js";
export function getSavedQueries(bookId, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        let response = yield new HttpBooksApiV5Request(`${bookId}/queries`, config).setMethod('GET').fetch();
        return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
}
export function createSavedQuery(bookId, query, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let response = yield new HttpBooksApiV5Request(`${bookId}/queries`, config).setMethod('POST').setPayload(query).fetch();
        return response.data;
    });
}
export function updateSavedQuery(bookId, query, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let response = yield new HttpBooksApiV5Request(`${bookId}/queries`, config).setMethod('PUT').setPayload(query).fetch();
        return response.data;
    });
}
export function deleteSavedQuery(bookId, queryId, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let response = yield new HttpBooksApiV5Request(`${bookId}/queries/${queryId}`, config).setMethod('DELETE').fetch();
        return response.data;
    });
}
//# sourceMappingURL=query-service.js.map